<div class="text-danger" *ngIf="control?.touched && control?.errors">
    <div *ngFor="let key of control.errors | objToKeys" [ngClass]="ngTextClass(key)">
        <i [ngClass]="ngClassIcon(key)"></i>  {{getDisplayError(key) | async}}
    </div>
</div>